<template>
  <div id="content_html" class="ssoContent">
      <!-- <object data="https://gitlab.infoglobal.id/users/sign_in" width="300" height="200"></object> -->
      <iframe id="ssoPageContainer" name="ssoPageContainer" :src="appSelected.link_url" title="SSO Infoglobal" type="text/html" width="100%" height="100%">
      </iframe>
      <div class="reverseLoading">
        <img
          class="brand-sso-apps"
          :src="require('@/assets/logo/apps/' + appSelected.logo)"
          alt
        />
        <span v-if="errorSSOtext==''">{{loadingSSOtext}}</span>
        <el-alert v-else
          :title="errorSSOtext"
          type="error"
          show-icon>
        </el-alert>
      </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import * as CryptoJS from 'crypto-js';

export default {
  props: ["id"],
  data() {
    return {
      detectHomePageSSO: null,
      keyCloakSSO: null,
      errorSSO: null,
      loop: {
        HomePageSSO: 0,
        keyCloakSSO: 0,
        errorSSO: 0,
      },
      errorSSOtext:"",
      loadingSSOtext:"Loading...",
      appSelected: {
        logo: "guide_1.png",
        link_url: ""
      },
    }
  },
  computed: {
    ...mapGetters({
      activeUser: "getActiveUser",
      listApps: "getListApps",
    }),
  },
  mounted(){
    this.getAPP()

    let that = this;
    window.onmessage = function(e) {
      if (e.data == 'callbackSSOSuccess') {
          that.keyCloakSSO = setInterval(() => {
            that.automationKeyCloakLogin();
          }, 2 * 1000)
          that.loadingSSOtext = "Waiting Autentication SSO!..."
      }else if(e.data == 'successSSOLoaded'){
        clearInterval(that.errorSSO)
        that.loadingSSOtext = "Redirecting to SSO Page!..."
        let url = that.listApps.filter((obj) => obj.app_ext_id==that.id)[0].link_url
        // window.location.href = url; 
        window.location.href = that.appSelected.link_url; 
      } else if(e.data.hello!=true && (!e.data.source && !e.data.key && !e.data.type )){
        if(e.data.indexOf('callbackSSOError;')>=0){
          that.loadingSSOtext = "An Error at Processing!"
          let err = e.data.split(";");
          that.errorSSOtext = err[1];
          clearInterval(that.errorSSO)
        }

      }else{
        if(that.loop.keyCloakSSO==5){
          // console.log("this.loop.keyCloakSSO", that.loop.keyCloakSSO)
          clearInterval(that.keyCloakSSO)
          return
        }
      }
    };

    this.detectHomePageSSO = setInterval(() => {
      this.automationLogin();
    }, 2 * 1000) // 2 detik
  },
  methods:{
    automationLogin(){
      var element = document.getElementById('ssoPageContainer');
      if(element!=null){
        this.loadingSSOtext = "Process Autentication SSO!..."
        if(this.appSelected.app_ext_id=='202209211310'){
          this.keyCloakSSO = setInterval(() => {
            this.automationKeyCloakLogin();
          }, 2 * 1000)
        }else{
				  element.contentWindow.postMessage("goToKeycloak","*");
        }
        clearInterval(this.detectHomePageSSO)
      }else{
        // console.log("this.loop.HomePageSSO", this.loop.HomePageSSO)
        if(this.loop.HomePageSSO==5){
          clearInterval(this.detectHomePageSSO)
          return
        }
      }
      
      this.loop.HomePageSSO += 1
    },
    automationKeyCloakLogin(){

      var element = document.getElementById('ssoPageContainer');
      if(element!=null){
        if(!this.activeUser.sso_enc){
          clearInterval(this.keyCloakSSO);
          this.resetPage();
        }else{
          let sso = this.decryptSSO(this.activeUser.sso_enc, process.env.VUE_APP_SSO_DECRYPTKEY)
          sso = JSON.parse(sso)

          let usr = this.activeUser.data.tlc
          if(this.appSelected.app_ext_id=='202209211310') // case khusus email
            usr = this.activeUser.details.email
          
          element.contentWindow.postMessage("setAuth;"+usr+";"+sso.psw,"*");
          clearInterval(this.keyCloakSSO);
          this.errorSSO = setInterval(() => {
              this.errorKeyCloakLogin();
            }, 2 * 1000)

          if(this.appSelected.app_ext_id=='202209211310') // case khusus email
            setTimeout(() => {
              document.location.href = this.appSelected.link_url;
            }, 2000);
        }
      }
    },
    errorKeyCloakLogin(){
      var element = document.getElementById('ssoPageContainer');
      if(element!=null){
        // console.log("anError",element)
        element.contentWindow.postMessage("anError","*");
      }
    },
    decryptSSO(encryptedBase64, key) {
      const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key);
      if (decrypted) {
        try {
          const str = decrypted.toString(CryptoJS.enc.Utf8);
          if (str.length > 0) {
            return str;
          } else {
            return {
              error: 'error 1'
            };
          } 
        } catch (e) {
          return {
            error: 'error 2'
          };
        }
      }
      return {
        error:'error 3'
      };
    },
    async getAPP(){
      await this.$store.dispatch("fetchAppsList")
    .then(()=> {
      this.appSelected =  this.listApps.filter((obj) => obj.app_ext_id==this.id)[0]
    });
    },
    resetPage(){
      this.$notify({
        type:"error",
        title: "Error",
        message: "Session of Single Sign On (SSO) is not Detected, please Log In again!"
      });
      localStorage.removeItem("token");
      this.$router.push({ name: "Home" });
    }
  }
}
</script>
<style lang="scss" scoped>
.ssoContent{
  background-color: darken(white, 2);
  display: block;
  // flex: 1;
  // flex-direction: column;
  height: 100vh;
  width: 100vw;
  // overflow: auto;
  z-index: 1;
}

#ssoPageContainer{
  display: none;
}

.reverseLoading{
  display: flex;
  flex-direction: column;
  align-items: center;
  // border: 5px solid;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
}

.brand-sso-apps{
  width: 75px;
}
</style>